module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "400px",
      "persistent": ""
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title"
  }, [_vm._v("\n      Map the Influencer on behalf\n    ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "body-2"
  }, [(_vm.postData) ? _c('p', [_vm._v("\n        The post is submitted by \n        "), (_vm.postData.submitedBy && _vm.postData.submitedBy.tiktokHandle) ? _c('strong', [_vm._v("@" + _vm._s(_vm.postData.submitedBy.tiktokHandle))]) : (_vm.postData.submitedBy && _vm.postData.submitedBy.youtubeHandle) ? _c('strong', [_vm._v("@" + _vm._s(_vm.postData.submitedBy.youtubeHandle))]) : (_vm.postData.submitedBy && _vm.postData.submitedBy.linkedinHandle) ? _c('strong', [_vm._v("@" + _vm._s(_vm.postData.submitedBy.linkedinHandle))]) : (_vm.postData.submitedBy && _vm.postData.submitedBy.instagramHandle) ? _c('strong', [_vm._v("@" + _vm._s(_vm.postData.submitedBy.instagramHandle))]) : _c('strong', [_vm._v("-")]), _vm._v("\n        for the "), _c('strong', [_vm._v(_vm._s(_vm.postData.campaignName))]), _vm._v(" campaign.\n      ")]) : _vm._e(), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.platform),
      callback: function($$v) {
        _vm.platform = $$v
      },
      expression: "platform"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Instagram",
      "value": "instagram"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "TikTok",
      "value": "tiktok"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Youtube",
      "value": "youtube"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "LinkedIn",
      "value": "linkedin"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prefix": "@",
      "label": "Handle",
      "block": "",
      "disabled": _vm.isValidating,
      "outlined": ""
    },
    model: {
      value: (_vm.handle),
      callback: function($$v) {
        _vm.handle = $$v
      },
      expression: "handle"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "red",
      "text": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "green",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.saveMappedInfluencer()
      }
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd0131e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Post/MapInfluencerModal.vue
// module id = 2281
// module chunks = 0